import React, { PureComponent } from 'react';
import styled from 'styled-components';
import colors from '@theme/colors';
import font from '@theme/font';
import { watermarkType } from '@molecules/Watermark/prop-types';

const WatermarkContainer = styled.span`
  color: ${colors.VERY_LIGHT_GREY};
  font-size: ${font.screen.size.MEDIUM};
  margin-top: 0px;
  margin-bottom: 35px;
  display: block;

  @media print {
    display: none;
  }
`;

export default class Watermark extends PureComponent {
  render() {
    const { name, emailAddress } = this.props.watermark;
    return (
      <WatermarkContainer>
        {name} – {emailAddress}
      </WatermarkContainer>
    );
  }
}

Watermark.propTypes = {
  watermark: watermarkType.isRequired,
};



// WEBPACK FOOTER //
// ./components/molecules/Watermark/Watermark.js